import { render } from "./status_body.vue?vue&type=template&id=7a64633e"
import script from "./status_body.js?vue&type=script&lang=js&external"
export * from "./status_body.js?vue&type=script&lang=js&external"

import "./status_body.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__